import { useStore } from '@stores';
import { useEffect } from 'react';

export const useRequestCount = (status: string): { totalCount: number; countloading: boolean } => {
  const { requestStore } = useStore();
  const { totalCount, countloading } = requestStore;

  useEffect(() => {
    requestStore.getTotalCount(status);
  }, [requestStore, status]);

  return { totalCount, countloading };
};
